<template>
	<div>
		<b-card no-body>
			<b-tabs card>
				<b-tab title="Tracking" active>
					<div class="row d-flex justify-content-center mb-70 mt-3 px-2">	
						<div class="col-md-12" v-if="!error">
							<div class="main-card mb-3">
								<b-overlay no-wrap :show="loading"></b-overlay>
								<b-row>
									<b-col class="mb-2" sm="12" lg="6">
										<!-- Service info -->
										<b-card tag="article" class="mb-2 card-custom">
											<b-card-text>
												<div class="d-flex justify-content-between">
													<h5 class="font-weight-bolder">Service</h5>
													<h5 class="text-muted font-weight-light">#{{ ride.serviceNumber }}</h5>
												</div>

												<div class="d-flex justify-content-between">
													<div>Sales Channel Ref.</div>
													<div class="text-muted font-weight-light">
														{{ ride.salesChannelReference }}
													</div>
												</div>

												<div class="d-flex justify-content-between">
													<div>Client</div>
													<div class="text-muted font-weight-light">
														{{ viewModel.client.firstName +" "+ viewModel.client.lastName }}
													</div>
												</div>

												<div class="d-flex justify-content-between">
													<div>Pickup Datetime</div>
													<div class="text-muted font-weight-light">
														{{ ride.pickupDatetime }}
													</div>
												</div>

												<div class="d-flex justify-content-between">
													<div><span class="text-danger font-weight-bolder">(A)</span>
														Pickup
													</div>
													<div class="text-muted font-weight-light">
														{{ pickupNamed }}
													</div>
												</div>

												<div class="d-flex justify-content-between">
													<div><span class="text-danger font-weight-bolder">(B)</span>
														Dropoff
													</div>
													<div class="text-muted font-weight-light">
														{{ dropoffNamed }}
													</div>
												</div>
											</b-card-text>
										</b-card>
										<!-- End service info -->
									</b-col>

									<b-col sm="12" lg="6">
										<!-- Assign driver section -->
										<label>Conductor:</label>
										<b-input-group>
											<template #prepend>
												<b-button
													variant="outline-info"
													@click="showNewDriverForm"
													v-if="$hasPermission('reservation.tracking.driver.add')">
													<md-icon :icon="'person_add'"></md-icon>
												</b-button>
											</template>

											<b-form-select
												:options="driversOpts"
												v-if="$hasPermission('reservation.tracking.assign')"
												v-model="driverSelected">
											</b-form-select>

											<template #append>
												<b-button
													variant="outline-primary"
													v-if="$hasPermission('reservation.tracking.assign')"
													@click="actions('assignDriver')">
													Asignar Conductor
												</b-button>
											</template>                       
										</b-input-group>
										<small class="text-muted">
											Este dato será distribuido (Ej. booking.com)
										</small>
										<!-- End Assign driver section -->
									</b-col>
								</b-row>

								<b-row>
									<b-col class="col-md-12">
                    <!-- Render google map -->
                    <g-map :ref="'map-tracking-status'" v-if="logsTrackStatus.length>0" @mounted="gmapMounted()"></g-map>
                    <div class="main-card">
                      <b-overlay :show="loading" no-wrap rounded></b-overlay>
                      <div v-if="logsTrackStatus.length==0 && !loading" class="text-center">
                        <label  class="text-center">
                          No se encontrarón resultados.
                        </label>
                      </div>
						
                      <b-table v-else 
                        :items="logsTrackStatus" 
                        :fields ="colsTableLogs" 
                        class="mt-3"
                        striped
                        hover
                        responsive
                        bordered
                        stacked="lg"
                        small>

                        <!-- A virtual column -->
                        <template #cell(index)="data">
                          <div class="text-center">
                          <span class="text-danger font-weight-bolder">({{ data.index + 1 }})</span>
                          </div>
                        </template>

                        <template #cell(transportServiceTrackingStatus)="row">
                          {{ row.item.transportServiceTrackingStatus }}
                        </template>

                        <template #cell(creationDatetime)="row">
                          <date-label :date="row.item.creationDatetime"/>
                        </template>
						<template #cell(creationDatetimeLocal)="row">
							<div>
								{{ row.item.creationDatetimeLocal }}
								<small class="text-muted">({{ row.item.timeZoneLocal }})</small>
							</div>
                        </template>
                      </b-table>
                    </div>
									</b-col>
								</b-row>

								<b-row v-if="false">
									<b-col class="col-md-5 mx-auto mt-2">
										<b-col class="text-center">
											<span>Tracking status:</span><br />
											<b-badge pill variant="primary" class="p-2">{{
												trackingStatusActual.text
											}}</b-badge
											><br />
											<md-icon
												:icon="'keyboard_double_arrow_down'"
											></md-icon>
										</b-col>
										<b-form-checkbox
											id="checkbox-1"
											class="text-center"
											v-if="trackingStatusActual.value == 'atPickup'"
											v-model="noShow"
										>
											No show
										</b-form-checkbox>
										<b-button
											v-if="
												!islastStatus &&
													$hasPermission(
														'reservation.tracking.changeStatus'
													)
											"
											class="mt-1"
											variant="outline-primary"
											block
											@click="showMsgBox()"
											>Actualizar a :
											<b>{{ trackingStatusNext.text }}</b></b-button
										>
									</b-col>
								</b-row>
							</div>

							<b-alert
								variant="warning"
								v-if="alert.show"
								show
								class="text-center"
								dismissible
							>
								{{ alert.text }}
							</b-alert>
						</div>
						<div class="col">
							<b-alert variant="danger" v-if="error" show class="text-center">
								No puede cargar debido a que la informacíon del ride es
								incorrecto,intente guardar los cambios antes de entrar al modulo
							</b-alert>
						</div>
					</div>
				</b-tab>
				<b-tab title="Driver Chat">
					<div class="p-2">
						<DriverChat :transportServiceId="ride.id"></DriverChat>
					</div>
				</b-tab>
			</b-tabs>
		</b-card>

		<b-modal
			:header-bg-variant="'info'"
			hide-footer
			ref="new-driver"
			size="md"
			:title="`Nuevo Conductor`"
		>
			<driverForm :supplierId="supplierId" @saved="driverSaved" />
		</b-modal>
	</div>
</template>

<script>
import api from "../../../../api.js";
import { mapState, mapMutations } from "vuex";
import driverForm from "./FormNewDriver";
import DateLabel from "../../../helpers/DateLabel.vue"
import gMap from "../../rate-plans/Map.vue"
import DriverChat from "./DriverChat.vue"
export default {
	name: "trackingForm",
	components: { driverForm, DateLabel ,gMap, DriverChat },
	data() {
		const modelDriver = { fullName: "", id: "" };
		return {
			error: false,
			modelDriver: modelDriver,
			loading: false,
			dataDrivers: [],
			driverInternal: { ...modelDriver }, //SC driver
			driverExternal: { ...modelDriver }, //booking spreaded
			trackStatusLogs:[],
			applyExternal: false,
			tsTimeZone:null,
			driverSelectedOption: "",
			alert: { show: false, text: "" },
			noShow: false,
			colsTableLogs: [
				{ key: 'index', label: 'Points'},
				{ key: 'transportServiceTrackingStatus', label: 'Track. status' },
				{ key: 'creationDatetime', label: 'Date Time UTC' },
				{ key: 'creationDatetimeLocal', label: 'Date time Local'},
				{ key: 'latitude', label: 'Lat.' },
				{ key: 'longitude', label: 'Lng.' },
				{ key: 'driverName', label: 'Conductor' },
			]
		};
	},
	methods: {
		...mapMutations("reservation", ["SET_UPDATE_TRANSPORT_SERVICE"]),
		showNewDriverForm() {
			this.$refs["new-driver"].show();
		},
		hideNewDriverForm() {
			this.$refs["new-driver"].hide();
		},
		resetDistributed() {
			this.applyExternal = false;
			this.driverExternal = { ...this.modelDriver };
			this.driverInternal = { ...this.modelDriver };
			this.trackStatusLogs= [];
			return;
		},

		fetchDrivers() {
			this.dataDrivers = [];
			this.loading = true;
			api(this)
				.get("/tracking/supplier/" + this.supplierId + "/drivers")
				.then(res => {
					this.dataDrivers = res.data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		fetchAssignedData() {
			this.resetDistributed();
			this.loading = true;
			api(this)
				.get("/tracking/driver/assigned/" + this.ride.id)
				.then(res => {
					this.applyExternal = res.data.applyExternal;
					this.driverExternal = res.data.driverExternal;
					this.driverInternal = res.data.driverInternal;
					this.trackStatusLogs = res.data.logsTrackingStatus;
					if (res.data.supplierId != this.ride.supplierId) {
						this.error = true;
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		actions(action) {
			let filters = { transportServiceId: this.ride.id };
			switch (action) {
				case "updateStatus":
					if (this.islastStatus) {
						this.$root.showAlert("Opción no valida", {
							variant: "danger"
						});
						return;
					}
					filters["trackingStatus"] = this.trackingStatusNext.value;
					break;
				case "assignDriver":
					if (this.driverSelectedOption == "") {
						this.$root.showAlert("Seleccione un conductor", {
							variant: "danger"
						});
						return;
					}
					if (this.driverSelectedOption === "default") {
						action = "restartDriver";
					}
					filters["driverId"] = this.driverSelectedOption;
					break;
				default:
					this.$root.showAlert("Opción no valida", {
						variant: "danger"
					});
					return;
			}
			this.loading = true;
			this.alert = { show: false, text: "" };
			api(this)
				.post("/tracking/actions/" + action, filters)
				.then(res => {
					let payload = {};
					switch (action) {
						case "updateStatus":
							payload = {
								index: this.index,
								data: {
									trackingStatus: this.trackingStatusNext
										.value
								}
							};
							this.SET_UPDATE_TRANSPORT_SERVICE(payload);

							break;
						case "assignDriver":
						case "restartDriver":
							setTimeout(() => {
								this.fetchAssignedData();
							}, 0);
							break;
					}
					this.$root.showAlert("Realizado con exito");
					if ("alert" in res.data) {
						this.alert = { show: true, text: res.data.alert[0] };
					}
				})
				.catch(this.$root.handleRequestError)
				.finally(() => {
					this.loading = false;
				});
		},
		showMsgBox() {
			this.boxTwo = "";
			this.$bvModal
				.msgBoxConfirm("¿Esta seguro que desea cambiar el status?.", {
					title: "Confirmación",
					size: "sm",
					buttonSize: "sm",
					okVariant: "primary",
					okTitle: "Si",
					cancelTitle: "Cancelar",
					footerClass: "p-2",
					hideHeaderClose: false,
					centered: false
				})
				.then(value => {
					if (value === true) {
						this.actions("updateStatus");
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		driverSaved(dataDriver) {
			this.fetchDrivers();
			this.driverInternal = {
				id: dataDriver.id,
				fullName: dataDriver.fullName
			};
			this.hideNewDriverForm();
		},
		gmapMounted(){
			this.$refs["map-tracking-status"].createMarks(this.gMarks)
		}
	},
	props: {
		index: Number
	},
	mounted() {
		this.fetchAssignedData();
		this.fetchDrivers();
		
	},
	beforeCreate() {
		this.$options.computed = {
			...mapState("reservation", ["viewModel"]),
			ride() {
				return { ...this.viewModel.transportServices[this.index] };
			},
			supplierId() {
				return this.ride.supplierId;
			},
			driversOpts() {
				let opts = [
					{ value: "default", text: "Asignar driver default" }
				];
				this.dataDrivers.forEach(element => {
					opts.push({
						value: element.id,
						text: element.fullName
					});
				});
				return opts;
			},
			driverSelected: {
				get: function() {
					return this.driverInternal.id;
				},
				set: function(val) {
					this.driverSelectedOption = val;
				}
			},
			trackingStatusActual() {
				return this.$root.getItemFromAuxVarOpts(
					"transportServiceTrackingStatusOpts",
					this.ride.trackingStatus
				);
			},
			trackingStatusNext() {
				let opts = [
					...this.$root.auxVars.transportServiceTrackingStatusOpts
				];
				let indexActual = opts.findIndex(el => {
					return el.value == this.ride.trackingStatus;
				});

				if (this.noShow) {
					let indexNoShow = opts.findIndex(el => {
						return el.value == "noShow";
					});
					return opts[indexNoShow];
				} else {
					let nextIndex = indexActual + 1;
					return opts[nextIndex];
				}
			},
			islastStatus() {
				return (
					this.ride.trackingStatus == "finished" ||
					this.ride.trackingStatus == "noShow"
				);
			},
			logsTrackStatus(){
				return this.trackStatusLogs;
			},
			placesRide(){
				return [{...this.ride.pickup},{...this.ride.dropoff}]
			},
			gMarks(){

				let arrayDriverTrack = [];

				let pp = {...this.ride.pickup};
				pp.label   = "A";
				pp.content = pp.name;
				let dp = {...this.ride.dropoff};
				dp.label   = "B";
				dp.content = dp.name;
				arrayDriverTrack.push(pp,dp);
				
				this.trackStatusLogs.forEach((item,index)=>{
					let itemMark  = {...item};
					itemMark.label=  (index+1).toString();
					itemMark.content= item.transportServiceTrackingStatus+"<br>"+item.creationDatetimeLocal;
					arrayDriverTrack.push(itemMark);
				})

				return arrayDriverTrack;
			},
			pickupNamed() {
				let pickup = this.ride.pickup.name
				return pickup.substring(0, 45)
			},
			dropoffNamed() {
				let dropoff = this.ride.dropoff.name
				return dropoff.substring(0, 45)
			}
		};
	}
};
</script>

<style scoped>

.card-header {
	padding: 0.3rem !important;
}
/** CHAT CSS */
.chat-container {
  max-width: 400px;
  margin: 0 auto;
}

.chat-messages {
  display: flex;
  flex-direction: column;
}

.message {
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 8px;
  max-width: 70%;
}

.sent {
  align-self: flex-end;
  background-color: #007bff;
  color: white;
}

.received {
  align-self: flex-start;
  background-color: #f4f4f4;
}

.card-custom {
    border-radius: 1rem;
  }
</style>
